import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { ShareIcon } from 'foundations-assets/icons/components/ShareIcon';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/transitional/components/View';
import { SelectableBox } from 'foundations-components/transitional/components/SelectableBox';
import { Small } from 'foundations-components/transitional/components/Small';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MONTH = 2629800000;
const CertificateButtonCompleted = ({
  name,
  trackId,
  onClick,
  expiresAt,
  isSelected
}) => {
  const history = useHistory();
  const {
    url
  } = useRouteMatch();
  const {
    search
  } = useLocation();

  // expiresAt will have value 0 for awards which never expire
  const isExpiringSoon = expiresAt === 0 ? false : expiresAt - MONTH < +Date.now();
  return /*#__PURE__*/_jsx(SelectableBox, {
    inlineSize: "max-content",
    marginBlockEnd: "400",
    minInlineSize: "248px",
    onClick: onClick,
    padding: "100",
    paddingInline: "400",
    selected: isSelected,
    type: "default",
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      flexDirection: "row",
      justifyContent: "end",
      children: [/*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        flexDirection: "column",
        inlineSize: "100%",
        children: [name, /*#__PURE__*/_jsx(Small, {
          use: "help",
          weight: "regular",
          children: isExpiringSoon ? /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: "learningCenter.mostPopularCertificates.expiring",
            options: {
              date: /*#__PURE__*/_jsx(FormattedDateTime, {
                format: "L",
                value: expiresAt
              })
            }
          }) : /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.mostPopularCertificates.completed"
          })
        })]
      }), /*#__PURE__*/_jsx(View, {
        blockSize: "60%",
        borderInlineStartColor: "border-interactive-default",
        borderInlineStartStyle: "solid",
        borderInlineStartWidth: "100",
        marginInlineStart: "250",
        onClick: e => {
          e.stopPropagation();
          const noTrailingUrl = url.length > 0 && url[url.length - 1] === '/' ? url.replace(/\/$/, '') : url;
          const link = `${noTrailingUrl}/award/${trackId}${search}`;
          history.push(link);
        },
        paddingInlineStart: "250",
        children: /*#__PURE__*/_jsx(ShareIcon, {
          color: "icon-core-subtle",
          size: "600"
        })
      })]
    })
  });
};
export default CertificateButtonCompleted;